import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import { UserRole, useAuth } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { useEffect } from "react";

interface ProtectedRoutesProps {
  allowedRoles?: UserRole[];
}

const ProtectedRoutes = ({ allowedRoles }: ProtectedRoutesProps) => {
  let context = useAuth();
  let navigate = useNavigate();
  const location = useLocation();

  const hasRequiredRole = allowedRoles?.some(role => context?.userRoles?.includes(role));

  // if (context?.loading) return <Loader />;
  console.log("##################");
  console.log(context?.currentUser?.emailVerified);
  console.log(context?.isMFAUser);
  console.log("##################");
  if (context?.currentUser && context.isMFAUser) {
    return <Outlet context={context} />;
  } else {
    return <Navigate to="/" />;
  }
};

export default ProtectedRoutes;
